import autoBind from "auto-bind";
import get from "lodash/get";

class PotencyRange {
  constructor(potencyRangeObject) {
    this.potencyRangeObject = potencyRangeObject;
    autoBind(this);
  }

  getMin() {
    return get(this.potencyRangeObject, "attributes.min");
  }

  getMax() {
    return get(this.potencyRangeObject, "attributes.max");
  }

  getUnit() {
    return get(this.potencyRangeObject, "attributes.unit");
  }
}

export default PotencyRange;
